import React, { FC } from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'

import { FeaturedPhotosPromoX3 } from 'components/block/FeaturedPhotosPromoX3/FeaturedPhotosPromoX3'
import { useFeaturedPhotosPromoX3 } from 'components/block/FeaturedPhotosPromoX3/hooks/useFeaturedPhotosPromoX3'
import { MainLayout } from 'components/designSystem/layout/MainLayout/MainLayout'
import featuredPhoto from 'components/designSystem/svg/promo-guarantee-views.svg'
import { Direction } from 'components/page/RatingWave/Rating.types'

export const FeaturedPhotos: FC<{
  onHandleClick?: (direction: Direction) => void
}> = ({ onHandleClick }) => {
  const { isFeaturedPhotosPromoX3Active } = useFeaturedPhotosPromoX3()

  const handlePrimaryClick = () => {
    onHandleClick?.(Direction.right)
  }
  const handleSecondaryClick = () => {
    onHandleClick?.(Direction.left)
  }

  return (
    <MainLayout
      title={
        <FormattedMessage
          id="featured_photos.notification.title"
          defaultMessage="Гарантированные показы"
        />
      }
      description={
        <FormattedMessage
          id="message.description.featured"
          defaultMessage="Больше лайков, больше внимания! Включай показы в Знакомствах и сияй"
        />
      }
      icon={
        isFeaturedPhotosPromoX3Active ? (
          <FeaturedPhotosPromoX3 size="M" />
        ) : (
          <Icon />
        )
      }
      backButtonVisible={false}
      onPrimaryButtonClick={handlePrimaryClick}
      onSecondaryButtonClick={handleSecondaryClick}
      primaryButtonText={
        <FormattedMessage
          id="form.button.activate"
          defaultMessage="Активировать"
        />
      }
      primaryButtonDataName="buy-featured-photo-action"
      secondaryButtonText={
        <FormattedMessage id="app.not_now" defaultMessage="Не сейчас" />
      }
      secondaryButtonColor="accent"
      secondaryButtonDataName="featured-photo-ignore-action"
      increasePaddingBottom={true}
      noBorder={true}
      wrapperStyle={featuredBackgroundStyle}
    />
  )
}

const Icon: FC = () => {
  return (
    <ParentIcon>
      <img src={featuredPhoto} draggable={false} />
    </ParentIcon>
  )
}

const ParentIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 200px;
  max-height: 200px;
  min-width: 50px;
  min-height: 50px;
  overflow: hidden;

  @media (min-height: 0) and (max-height: 560px) {
    max-height: 110px;
    max-width: 110px;
  }

  @media (min-height: 561px) and (max-height: 600px) {
    max-height: 120px;
    max-width: 120px;
  }

  > * {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

const featuredBackgroundStyle = {
  backgroundColor: 'var(--purpur-opacity-default)',
}
